class Monitoring.Models.ContentBeautifier.Translator

  constructor: (@content, @replacement_pattern) ->
    # nothing to do

  replace: (match) ->
    replacement = @replacement_pattern.split('%{match}').join(match) # replace all
    @content.split(match).join(replacement) # replace all
